export const CountryPackageNoPrice = () => {
    return <div className="un_product"></div>
}

export const PackageNoPrice = () => {
    return <div className="package_price_container"></div>
}

